/**
 * 错误信息类
 */
export default class ErrorInfo {
    constructor(code, message) {
        this.code = code;
        this.message = message;
    }
}
